import styled from "styled-components";

export type PillState =
  | "success"
  | "error"
  | "warn"
  | "incomplete"
  | "info"
  | "submitted"
  | "cancelled"
  | "in progress"
  | "partial";

// Gets the correct Pill state colour
export const getStatusColor = (state: PillState) => {
  switch (state) {
    case "success":
      return "rgb(0, 138, 0)";
    case "error":
      return "rgb(189, 0, 0)";
    case "warn":
      return "rgb(189, 0, 0)";
    case "incomplete":
      return "rgb(190, 190, 190)";
    case "info":
      return "rgb(0, 94, 165)";
    case "submitted":
      return "rgb(235, 151, 0)";
    case "in progress":
      return "rgb(0, 124, 146)";
    case "cancelled":
      return "rgb(189, 0, 0)";
    case "partial":
      return "rgb(156,41,160)";
    default:
      return "rgb(189, 0, 0)";
  }
};

const RoundedPillStyles = styled.div<{ state: PillState }>`
  span {
    display: flex;
    color: ${({ state }) => getStatusColor(state)};
    border: 1px solid ${({ state }) => getStatusColor(state)};
    font-weight: normal;
    font-size: 16px;
    background-color: transparent;
    justify-content: center;
    width: auto;
    max-width: 155px;
  }
`;
export default RoundedPillStyles;
